<div class="fs-2 danger with-close" mat-dialog-title>
    Suppression de compte
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p>
        Information sur la suppression de votre compte LyBox:
    </p>
    <ul>
        <li>Vous perdrez l'ensemble des données et des contenus de ce compte, tels que les recherches, les favoris et les simulations</li>
        <li>Vous ne pourrez plus vous connecter sur votre compte LyBox.</li>
        <li>La suppression de votre compte n'entrainera aucun remboursement des abonnements en cours.</li>
    </ul>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>

    <button type="button" (click)="onYesClick()" class="btn btn-danger float-right">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Supprimer mon compte</ng-container>
    </button>
</div>
